import { calcSpacing } from 'src/components/foundations';
import styled from 'styled-components';

export const PageWrapper = styled.div<{ $scrollLocked?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  position: relative;
  overflow-x: hidden;
  overflow-y: ${(props) => (props.$scrollLocked ? 'hidden' : 'auto')};
`;

export const FormCreationMainColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  position: relative;
`;

export const PageLoadingOverlay = styled.div<{ $zIndex?: number }>`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: ${(props) => props.$zIndex ?? 9999};
  pointer-events: auto;
`;

export const PageContent = styled.div`
  flex: 1;
  padding: ${calcSpacing(2.5)}px;
  /* Large bottom padding ensures language dropdown remains visible when all languages are selected */
  padding-bottom: ${calcSpacing(30)}px;
`;

export const GridMainColumn = styled.div`
  grid-column: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const CategoryWarningBannerWrapper = styled.div`
  width: 100%;

  > div {
    border: none;
    align-items: center;
    border-radius: 8px;
  }

  p {
    font-weight: 400;
    color: ${(props) => props.theme.atlas.semantic.color.status.warning.text};
  }
`;

export const GridContainer = styled.div<{ $narrowConfigColumn?: boolean }>`
  display: grid;
  grid-template-columns: ${(props) =>
    props.$narrowConfigColumn ? '1fr 302px' : '1fr 400px'};
  column-gap: ${calcSpacing(2.5)}px;
  align-items: start;
  min-width: 0;

  @media screen and (max-width: 1200px) {
    grid-template-columns: ${(props) =>
      props.$narrowConfigColumn ? '1fr 280px' : '1fr 350px'};
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    row-gap: ${calcSpacing(2.5)}px;
  }
`;

export const MainContent = styled.div<{ $isInitialState?: boolean }>`
  display: flex;
  flex-direction: column;
  min-width: 0;
  ${({ $isInitialState }) =>
    $isInitialState &&
    `
    justify-content: center;
    min-height: calc(100vh - 200px);
  `}
`;

export const ConfigSidebar = styled.div`
  display: flex;
  flex-direction: column;
  position: sticky;
  top: ${calcSpacing(2.5)}px;
  min-width: 0;

  @media screen and (max-width: 768px) {
    position: static;
  }
`;

export const FormTranslatingPaneOverlay = styled.div<{ $zIndex?: number }>`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: ${(props) => props.$zIndex ?? 10000};
  pointer-events: auto;
  overflow: hidden;
`;

export const FormTranslationOverlayStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${calcSpacing(3)}px;
  max-width: 420px;
  padding: 0 ${calcSpacing(2)}px;
`;

export const FormTranslationOverlayCopy = styled.p`
  margin: 0;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;
